export default "__VITE_ASSET__BVF0dvzL__"